import Phaser from "phaser"

import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { Base, ModuleCollection } from "../cGameObjects/modules";
import { DisplayRect,helper } from "../cGameObjects/helper";
import { cGame } from "../cGame";


export class Character extends Phaser.GameObjects.Container {

  public readonly isContainer: boolean = true;

  public person: any = {};
  public modules: ModuleCollection;
  private sData!: any ;
  private cc:number = 0;
  private sDelay!: number;

  private curScale: number = 0.5;
  private char_body!: Phaser.GameObjects.Sprite;
  private char_extra!: Phaser.GameObjects.Sprite;
  
  private char_head!: Phaser.GameObjects.Sprite;

  private char_legs!: Phaser.GameObjects.Sprite;
  private char_legs_frame: string = '';
  private char_walk_timeout: any = 0;

  private char_mouth!: Phaser.GameObjects.Sprite;
  private char_mouth_frame: string = '';

  private char_eyes!: Phaser.GameObjects.Sprite;
  private char_eyes_frame: string = '';
  private isBlink: boolean = false;

  private char_head_container!: Phaser.GameObjects.Container;

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0);
    this.modules = Base.initModules(this,data);

    switch (data.asset){
      case "char_lucie":
        this.person = {
          name:'lucie',
          legs: {x:40,y:300},
          head: {x:70,y:-270},
          eyes: {x:13,y:24},
          mouth: {x:0,y:110},
          extra: 'pferdeschwanz.png',
          extrapos:{x:-120,y:-110}
        }
        this.cc = 50;
        this.sDelay = 400;
        break;

      case "char_oskar":
      default:
        this.person = {
          name:'oskar',
          legs: {x:23,y:300},
          head: {x:10,y:-320},
          eyes: {x:53,y:24},
          mouth: {x:58,y:110}
        }
        this.sDelay = 0;
        break;
    }

    this.scaleX = this.curScale;
    this.scaleY = this.curScale;
    this.sData = data;
    this.setupBody()

    //this.setupDebug(sc);
    
    sc.events.on('render',()=>{
      this.update();
    })
  }

  setupDebug(sc:any){
    if (sc.debugMode){
      let _debugRect = new Phaser.GameObjects.Graphics(sc) //  this.ref.add.graphics();

      var r:any = this.modules.layout.getOfs( '' )
      if (!r) r={x:100,y:100}

      _debugRect.lineStyle(1, 0xff9900, 0.8);
      _debugRect.x = 0;
      _debugRect.y = 0;      
      _debugRect.fillStyle(0xff9900,0.2)
      _debugRect.fillRect(0,0,r.x,r.y)
      _debugRect.strokeRect(0, 0, r.x, r.y);
      this.add(_debugRect)
    }    
  }

  setupBody(){
    if (this.sData){
    }

    this.char_legs = new Phaser.GameObjects.Sprite(this.scene,this.person.legs.x,this.person.legs.y, this.sData.asset,'beine-stehen.png');
    this.char_legs_frame = 'beine-stehen.png';
    this.scene.add.existing(this.char_legs);
    this.add(this.char_legs);

    var animcfg = {
      key:'char_walk_' + this.person.name,
      frameRate: 6,
      repeat: -1,
      frames: this.scene.anims.generateFrameNames(this.sData.asset,{
        prefix:'beine-gehen-',
        suffix:'.png',
        start:1,
        end:4,
      })    
    }

    this.char_legs.anims.create(animcfg);

    if (this.person.extra){
      this.char_extra = new Phaser.GameObjects.Sprite(this.scene, this.person.extrapos.x,this.person.extrapos.y, this.sData.asset, this.person.extra  );
      this.add(this.char_extra);  
    }


    this.char_body = new Phaser.GameObjects.Sprite(this.scene,0,0, this.sData.asset,'oberkoerper.png'  );
    this.add(this.char_body);
    
    this.char_head_container = new Phaser.GameObjects.Container(this.scene,this.person.head.x,this.person.head.y);
    this.add(this.char_head_container);

    this.char_head = new Phaser.GameObjects.Sprite(this.scene,0,0, this.sData.asset,'kopf.png'  );
    this.char_head_container.add(this.char_head);

    this.char_eyes = new Phaser.GameObjects.Sprite(this.scene,this.person.eyes.x, this.person.eyes.y, this.sData.asset,'augen-unten.png');
    this.char_eyes_frame = 'augen-unten.png';
    this.char_head_container.add(this.char_eyes);

    this.char_mouth = new Phaser.GameObjects.Sprite(this.scene,this.person.mouth.x, this.person.mouth.y, this.sData.asset,'mund-offen.png');
    this.char_mouth_frame = 'mund-offen.png';
    this.char_head_container.add(this.char_mouth);

    this.mouth = 'smile'
  }

  setupLegs(){

  }

  updateEyes(){
    if (this.isBlink){
      this.char_eyes.setFrame('augen-zu.png' )
    }else{
      this.char_eyes.setFrame( this.char_eyes_frame )
    }
  }

  updateMouth(){
    this.char_mouth.setFrame( this.char_mouth_frame )
  }

  update(){
    this.cc++;
    if (this.cc % 180 === 0 && !this.isBlink){
      this.isBlink = true;
      this.updateEyes();
      setTimeout(()=>{
        this.isBlink = false;
        this.updateEyes();
      },100)      
    }
    //this.char_head_container.setAngle( 4 )
  }

  public set eyes(v:string){
    var map:any = {
      up:'augen-oben.png',
      down:'augen-unten.png',
      left:'augen-links.png',
      right:'augen-rechts.png',
      closed:'augen-zu.png'
    }
    if (map[v]){
      this.char_eyes_frame = map[v];
      this.updateEyes();
    }
  }

  public set mouth(v:string){
    var map:any = {
      closed:'mund-zu.png',
      open:'mund-offen.png',
      smile:'mund-lachen.png',
    }
    if (map[v]){
      this.char_mouth_frame = map[v];
      this.updateMouth();
    }    
  }


  public set walk(v:string){

    var snd = (this.scene as cScene).snd('sound_walking',{loop:true,delay:this.sDelay})
    snd.volume = 0.5;
    snd.play()    

    if (this.char_legs){
      if (this.char_walk_timeout){
        clearTimeout(this.char_walk_timeout)
      }
      this.char_legs.play('char_walk_' + this.person.name);
      this.char_walk_timeout = setTimeout(()=>{
        if (this.char_legs && this.char_legs.anims){          
          this.char_legs.stop();
          this.char_legs.setFrame( this.char_legs_frame );
          snd.stop();
        }
      },Number(v))
    }
  }

  public set look(v:string){
    switch (v){
      case 'left':
        this.scaleX = -this.curScale;
        break;
      case 'right':
        this.scaleX = this.curScale;
        break;
    }
  }

  public set walkto(v:string){
    if (!v || typeof v != 'string') return
    var [xx,yy,time] = v.split('x');
    var props:any = {
      targets:this,
      duration: Number(time)
    }
    if (!isNaN(Number(xx)) ) props.x = Number(xx);
    if (!isNaN(Number(yy)) ) props.y = Number(yy);

    this.scene.tweens.add(props)
    this.walk = time;
  }

  public set charBody(v:string){ 
    if (v){
      this.char_body.setTexture(v)
    }else{
      this.char_body.setTexture(this.sData.asset,'oberkoerper.png')
    }
  }

  public set charBodyPos(v:string){ 
    if (v){
      var p:any = this.modules.layout.getOfs(v);
      this.char_body.setPosition(p.x,p.y);  
    }else{
      this.char_body.setPosition(0,0);  
    }
  }

  public set hide(val:string){
    var s:string[] = val.split(',');
    s.forEach((v)=>{
      switch (v){
        case 'legs': this.char_legs.visible = false; break;
      }  
    })
  }




  public walkinout(val:string,delay:number,options:any,cb:Function){

    if ( (this.scene as cScene).debugMode){
      cb()
      return
    }

    var charWidth: number = 150
    var [dir,side] = String(val).split('_');
    var rect: DisplayRect = helper.getDisplayRect(cGame.current.sceneGlobal)
    var dist:number = Math.abs((side === 'left') ? this.x - (rect.left-charWidth) : this.x - (rect.right+charWidth)) * 3.5
    var props:any
    var walkOptions:any = options ? JSON.parse(options) : {}

    delay = delay ? delay : 0
    if (dir === 'from'){
      props = {
        x: this.x,        
      }
      this.x = (side === 'left') ? rect.left - charWidth : rect.right + charWidth
      if (side === 'left' && this.scaleX < 0) this.scaleX *= -1
      if (side === 'right' && this.scaleX > 0) this.scaleX *= -1

      if (walkOptions.out_shift_y){
        this.y = this.modules.layout.origin_y + Number(walkOptions.out_shift_y)
        props.y = this.modules.layout.origin_y
      }

      if (walkOptions.out_scale){
        var i = this.modules.layout.initProps;
        this.scaleX = Number(walkOptions.out_scale) * (i.scaleX ? Number(i.scaleX) : 1)
        this.scaleY = Number(walkOptions.out_scale) * (i.scaleY ? Number(i.scaleY) : 1)
        props.scaleX = Number(i.scaleX)
        props.scaleY = Number(i.scaleY)
      }      

    }else{
      props = {
        x: (side === 'left') ? rect.left - charWidth : rect.right + charWidth,
      }
      if (side === 'left' && this.scaleX > 0) this.scaleX *= -1
      if (side === 'right' && this.scaleX < 0) this.scaleX *= -1

      if (walkOptions.out_shift_y){
        props.y = this.modules.layout.origin_y + Number(walkOptions.out_shift_y)
      }

      if (walkOptions.out_scale){
        var i_s = this.modules.layout.initProps;
        props.scaleX = -Number(walkOptions.out_scale) * (i_s.scaleX ? Number(i_s.scaleX) : 1)
        props.scaleY = Number(walkOptions.out_scale) * (i_s.scaleY ? Number(i_s.scaleY) : 1)
      }
      
    }

    var time = dist;
    props.targets = this
    props.duration = dist
    props.onComplete = ()=>{
      if (walkOptions.flip_at_end){
        this.scaleX = Number(walkOptions.flip_at_end)
      }
      cb && cb()
    }


    setTimeout(()=>{
      this.scene.tweens.add(props);
      this.walk = String(time);  
    },delay)



    
  }

}